import { Box, Button, Typography, Grid, RadioGroup, FormControlLabel, Radio, Checkbox, Tooltip, IconButton, InputAdornment, TextField, Collapse, Divider, CircularProgress, Tabs, Tab } from '@mui/material';
import CustomDatePicker from '../../CustomDatePicker';
import CurrencyDropdown from '../../CurrencyDropdown';
import TextArea from '../../TextArea';
import dayjs from 'dayjs';
import CustomDropdown from '../../CustomDropdownWithPlus';
import './index.css'
import CustomTextField from '../../CustomTextField';
import { useParams } from 'react-router-dom';
import { useEffect, useState, useMemo } from 'react';
import { getSingleinvoice, updateInvoice, fetchInvoiceEmailHistoryByOrder } from '../../../services/invoices';
import { fetchAddressList } from '../../../services/address';
import { getTerms } from '../../.../../../services/terms';
import { getTaxes } from '../../.../../../services/tax';
import ButtonLoader from '../../ButtonLoader/index.js';
import { getCustomerDetails } from '../../../services/customer/index.js';
import toast from 'react-hot-toast';
import LoadingComponent from '../../../components/ComponentLoader';
import { convertAddressToString } from '../../../utils/common.js';
import { getAllClientAccounts } from '../../../services/shipping'
import { fetchSuppliersList } from "../../../services/suppliers/index.js";
import SearchIcon from '@mui/icons-material/Search';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import PublicOutlinedIcon from '@mui/icons-material/PublicOutlined';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';
import PaletteOutlinedIcon from '@mui/icons-material/PaletteOutlined';
import { formatInvoiceTotal, resolveInvoiceTotalAmount } from './invoiceEditDisplay';
import InvoiceCartTab from './InvoiceCartTab';
import SalesOrderInvoiceEmailHistory from '../../../pages/instances/sales/orders/orders-single/SalesOrderInvoiceEmailHistory';

const currencyOptions = [
    { id: 'USD', name: 'USD' },
    { id: 'EUR', name: 'EUR' },
    { id: 'GBP', name: 'GB' },
    { id: 'CAD', name: 'CA' },
    { id: 'INR', name: 'INR' },
];

const statusOptions = [
    { id: 'Open', name: 'Open' },
    { id: 'Sent To Client', name: 'Sent To Client' },
    { id: 'Exported', name: 'Exported' },
    { id: 'Paid', name: 'Paid' },
]

const paymentTypeOptions = [
    { id: 'cheque', name: 'Cheque' },
    { id: 'etf', name: 'EFT' },
];

const isPaidLikeInvoice = (invoice = {}) => {
    const paymentStatus = String(invoice?.paymentStatus || '').trim().toLowerCase();
    const invoiceStatus = String(invoice?.invoiceStatus || '').trim().toLowerCase();
    return ['paid', 'completed', 'succeeded', 'success'].includes(paymentStatus)
        || ['paid', 'completed'].includes(invoiceStatus);
};

const getInvoiceModeLabel = (invoice = {}) => {
    const paymentMethod = String(invoice?.paymentMethod || '').trim().toLowerCase();
    if (paymentMethod === 'customer_selection') return 'Customer Selection';
    if (paymentMethod === 'manual' || paymentMethod === 'others' || invoice?.paymentType) return 'Manual';
    if (invoice?.checkoutLink || invoice?.checkoutSessionId || paymentMethod === 'stripe') return 'Stripe';
    return 'Manual';
};

const InvoiceEdit = ({
    orderId, order, clientContacts, setInvoiceModalOpen, fetchInvoicesList, handleClose, onOpenResendInvoice, invoicingCartKey = null, activeInvoicingCartSummary = null
}) => {
    const currentDate = dayjs();
    const { tabId, instanceUniqueId } = useParams();
    const isGeneratedInvoice = !!tabId && tabId !== 'new';
    const [termsOptions, setTermsOptions] = useState([]);
    const [taxOptions, setTaxOptions] = useState([]);
    const [loading, setLoading] = useState(false)
    const [addressOptions, setAddressOptions] = useState([])
    const [allCustomerAddresses, setAllCustomerAddresses] = useState([]);
    const [allGlobalAddresses, setAllGlobalAddresses] = useState([]);
    const [addressScope, setAddressScope] = useState('customer');
    const [addressQuery, setAddressQuery] = useState('');
    const [contactsOptions, setContactsOptions] = useState([])
    const [customerContactsOptions, setCustomerContactsOptions] = useState([]);
    const [supplierContactsOptions, setSupplierContactsOptions] = useState([]);
    const [thirdPartyContactsOptions, setThirdPartyContactsOptions] = useState([]);
    const [formData, setFormData] = useState({
        status: 'Open',
        invoiceDate: currentDate || dayjs(),
        introduction: '',
        billingAddress: '', // printable snapshot
        billingAddressId: '', // reference id
        billingAddressDisplay: '',
        billingName: '',
        billingContactId: '',
        billingId: '', // legacy compatibility
        shippingAddress: '', // printable snapshot
        shippingAddressId: '', // reference id
        shippingAddressDisplay: '',
        shippingName: '',
        shippingContactId: '',
        selectedBillingAddress: null,
        selectedMainShippingAddress: null,
        shippingId: '', // legacy compatibility
        terms: null,
        currency: 'CAD',
        inHandsDate: currentDate || dayjs(),
        defaultTax: null,
        invoiceView: 'Detail',
        paymentType: '',
        ChequeNumber: '',
        accountHolderName: '',
        bankName: '',
        bankAccountNumber: '',
        routingNumber: '',
        paymentReceivedAmount: '',
        paymentReceivedDate: '',
        paymentNotes: '',
        finalizeManualPayment: false,

    });
    const [invoiceModeLabel, setInvoiceModeLabel] = useState('Customer Selection');
    const [stripeCheckoutLink, setStripeCheckoutLink] = useState('');
    const [manualErrors, setManualErrors] = useState({});
    const [currentInvoice, setCurrentInvoice] = useState(null);
    const [activeEditTab, setActiveEditTab] = useState('details');
    const [invoiceEmailHistory, setInvoiceEmailHistory] = useState({ events: [], loading: false, error: '' });
    const [invoiceEmailHistoryRefresh, setInvoiceEmailHistoryRefresh] = useState(0);
    const [showInvoiceCustomization, setShowInvoiceCustomization] = useState(false);
    const [customizationOptionsLoaded, setCustomizationOptionsLoaded] = useState(false);
    const [customizationOptionsLoading, setCustomizationOptionsLoading] = useState(false);
    const isManualMode = String(invoiceModeLabel).toLowerCase() === 'manual';
    const hasStripeEvidence = useMemo(() => {
        const paymentMethod = String(currentInvoice?.paymentMethod || '').trim().toLowerCase();
        return paymentMethod === 'stripe' || !!currentInvoice?.checkoutLink || !!currentInvoice?.checkoutSessionId;
    }, [currentInvoice]);
    const isAlreadyPaidStripeInvoice = useMemo(
        () => isPaidLikeInvoice(currentInvoice) && hasStripeEvidence,
        [currentInvoice, hasStripeEvidence]
    );

    const handleSelect = (event, name) => {
        const selectedValue = event.target.value;
        if (name === 'billingAddressId' || name === 'shippingAddressId') {
            const source = (addressDropdownOptions || []).find((opt) => String(opt.id) === String(selectedValue));
            const nextDisplay = source
                ? (source.display || source.name || '')
                : String(selectedValue || '');
            const displayField = name === 'billingAddressId' ? 'billingAddressDisplay' : 'shippingAddressDisplay';
            const snapshotField = name === 'billingAddressId' ? 'billingAddress' : 'shippingAddress';
            setFormData({
                ...formData,
                [name]: selectedValue,
                [displayField]: nextDisplay,
                [snapshotField]: nextDisplay,
            });
            return;
        }
        if (name === 'billingContactId' || name === 'shippingContactId') {
            const source = (contactsOptions || []).find((opt) => String(opt.id) === String(selectedValue));
            const nextName = source?.name || '';
            const snapshotField = name === 'billingContactId' ? 'billingName' : 'shippingName';
            const legacyField = name === 'billingContactId' ? 'billingId' : 'shippingId';
            setFormData({
                ...formData,
                [name]: selectedValue,
                [snapshotField]: nextName,
                [legacyField]: selectedValue,
            });
            return;
        }
        setFormData({
            ...formData,
            [name]: selectedValue
        });
    };

    const handleInputChange = (event, name) => {
        const nextValue =
            event?.target?.type === 'checkbox'
                ? !!event?.target?.checked
                : event?.target?.value;
        setFormData({
            ...formData,
            [name]: nextValue,
        });
    };

    const toIdValue = (value) => {
        if (value && typeof value === 'object') return value.id || '';
        return value || '';
    };
    const normalizeText = (value) => String(value || '').trim().toLowerCase();
    const findContactIdByText = (rawValue) => {
        const text = normalizeText(rawValue);
        if (!text) return '';
        const match = (contactsOptions || []).find((option) => {
            const optionId = normalizeText(option?.id);
            const optionName = normalizeText(option?.name);
            const optionEmail = normalizeText(option?.email);
            return text === optionId || text === optionName || (optionEmail && text === optionEmail);
        });
        return match ? String(match.id) : '';
    };
    const findAddressIdByText = (rawValue, options = []) => {
        const text = normalizeText(rawValue);
        if (!text) return '';
        const match = (options || []).find((option) => {
            const optionId = normalizeText(option?.id);
            const optionName = normalizeText(option?.name);
            const optionDisplay = normalizeText(option?.display);
            const optionLabel = normalizeText(option?.label);
            const optionAddressName = normalizeText(option?.addressName || option?.address?.addressName);
            return text === optionId || text === optionName || text === optionDisplay || text === optionLabel || text === optionAddressName;
        });
        return match ? String(match.id) : '';
    };
    const resolveAddressId = (rawId, rawText, options = []) => {
        const id = String(rawId || '').trim();
        if (id && (options || []).some((opt) => String(opt?.id) === id)) return id;
        if (id && /^\d+$/.test(id)) {
            const custId = `cust-${id}`;
            if ((options || []).some((opt) => String(opt?.id) === custId)) return custId;
        }
        const exact = findAddressIdByText(id || rawText, options);
        if (exact) return exact;
        const text = normalizeText(rawText);
        if (!text) return '';
        const containsMatch = (options || []).find((option) => {
            const candidates = [
                option?.addressName,
                option?.address?.addressName,
                option?.label,
                option?.name,
                option?.display,
            ]
                .map((v) => normalizeText(v))
                .filter(Boolean);
            return candidates.some((value) => value.includes(text) || text.includes(value));
        });
        return containsMatch ? String(containsMatch.id) : '';
    };
    const handleOpenSendEmail = () => {
        if (typeof onOpenResendInvoice === 'function' && currentInvoice?.id) {
            onOpenResendInvoice(currentInvoice);
            return;
        }
        toast.error('Invoice email composer is unavailable.');
    };

    const handleDateChange = (date, name) => {
        setFormData({
            ...formData,
            [name]: date
        });
    };
    const fetchTermsAndTaxes = async () => {
        try {
            const termsData = await getTerms();
            const taxesData = await getTaxes();
            let addressResponse = await fetchAddressList();

            // addressResponse = addressResponse
            // ?.map((address) => ({
            //     id: address.id,
            //     name: address.addressName
            // }))
            const suppliers = await fetchSuppliersList();

            let thirdPartyAccounts = await getAllClientAccounts()

            thirdPartyAccounts = thirdPartyAccounts?.data?.map((account) => ({
                id: account.id,
                name: account.accountName,
            }))
            
            setSupplierContactsOptions(suppliers.map(s => ({ ...s, type: 'supplier' })));
            setThirdPartyContactsOptions(thirdPartyAccounts.map(t => ({ ...t, type: 'third-party' })));

            const normalizedGlobalAddresses = (Array.isArray(addressResponse) ? addressResponse : []).map((address) => ({
                ...address,
                id: address?.id ?? convertAddressToString(address),
                name: address?.addressName || `${address?.streetAddress || address?.street || ''} - ${address?.city || ''}`,
                display: convertAddressToString(address),
                source: 'global',
            }));
            setAllGlobalAddresses(normalizedGlobalAddresses);
            setTermsOptions(termsData?.terms || []);
            setTaxOptions(taxesData?.taxes || []);

        } catch (error) {
            console.error('Error fetching terms or taxes:', error);
        }
    };
    const fetchCustomerDetails = async () => {
        try {
            const attachedCustomers = Array.isArray(order?.attachedCustomers)
                ? order.attachedCustomers
                : (typeof order?.attachedCustomers === 'string'
                    ? (() => {
                        try {
                            const parsed = JSON.parse(order.attachedCustomers);
                            return Array.isArray(parsed) ? parsed : [];
                        } catch {
                            return [];
                        }
                    })()
                    : []);
            const customerId = attachedCustomers.find((value) => value != null && String(value).trim() !== '');
            if (!customerId) return;

            const customerDetails = await getCustomerDetails(customerId);
            const rawCusContacts = customerDetails?.customer?.clientContacts || [];
            const parsedCusContacts = Array.isArray(rawCusContacts)
                ? rawCusContacts
                : (typeof rawCusContacts === 'string'
                    ? (() => {
                        try {
                            const parsed = JSON.parse(rawCusContacts);
                            return Array.isArray(parsed) ? parsed : [];
                        } catch {
                            return [];
                        }
                    })()
                    : []);

            const cusContacts = parsedCusContacts.filter((contact) => !contact?.mergedIntoContactId).map((contact, index) => {
                const contactId = contact?.id ?? contact?.ContactId ?? contact?.contactId ?? `cust-${customerId}-${index}`;
                const contactName = contact?.name || [contact?.firstName, contact?.lastName].filter(Boolean).join(' ').trim();
                const email = contact?.email || contact?.Email || '';
                return {
                    ...contact,
                    id: String(contactId),
                    name: contactName || email || `Contact ${index + 1}`,
                    email,
                    type: 'client',
                };
            });
            setCustomerContactsOptions(cusContacts);

            const buildDisplay = (a = {}) => {
                const line1 = a.street || a.streetAddress || "";
                const line2 = [a.city, a.state || a.stateProvince].filter(Boolean).join(", ");
                const parts = [
                    a.addressName || a.label,
                    line1,
                    line2,
                    a.postal || a.postalZipCode,
                    a.country,
                ].filter(Boolean);
                return parts.join(" · ");
            };
            const formattedAddresses = (customerDetails?.customer?.address || []).map((address, index) => {
                const rawAddressId = address?.id ?? address?.addressId ?? address?.AddressId;
                const id = rawAddressId !== null && rawAddressId !== undefined && String(rawAddressId).trim() !== ''
                    ? `cust-${String(rawAddressId).trim()}`
                    : `cust-${index}`;
                const display = convertAddressToString(address) || buildDisplay(address);
                return {
                    ...address,
                    id,
                    addressName: address.addressName || address.label || '',
                    label: address.addressName || address.label || display,
                    name: display,
                    display,
                    address,
                    source: 'customer',
                };
            });

            setAllCustomerAddresses(formattedAddresses || []);

        } catch (error) {
            console.error('Error fetching terms or taxes:', error);
        }
    };
    const updateEstimationDetails = async () => {
        try {
            const normalizedPaymentType = String(formData.paymentType || '').toLowerCase();
            const normalizeText = (value) => String(value || '').trim();
            const nextManualErrors = {};
            const wantsManualPaidOverride = !!formData.finalizeManualPayment;

            if (isManualMode && wantsManualPaidOverride) {
                if (!normalizedPaymentType) {
                    nextManualErrors.paymentType = 'Manual payment type is required.';
                }
                if (normalizedPaymentType === 'cheque') {
                    if (!normalizeText(formData.ChequeNumber)) {
                        nextManualErrors.ChequeNumber = 'Cheque number is required.';
                    }
                    if (!normalizeText(formData.accountHolderName)) {
                        nextManualErrors.accountHolderName = 'Account holder name is required.';
                    }
                }
            }
            if (wantsManualPaidOverride) {
                if (!normalizeText(formData.paymentNotes)) {
                    nextManualErrors.paymentNotes = 'Additional notes are required.';
                }
            }

            if (Object.keys(nextManualErrors).length) {
                setManualErrors(nextManualErrors);
                toast.error('Please complete required manual payment fields.');
                return;
            }
            setManualErrors({});

            const payload = {
                invoiceStatus: formData.status,
                billingName: normalizeText(formData.billingName) || null,
                shippingName: normalizeText(formData.shippingName) || null,
                billingContactId: toIdValue(formData?.billingContactId),
                shippingContactId: toIdValue(formData?.shippingContactId),
                billingAddressId: toIdValue(formData?.billingAddressId),
                shippingAddressId: toIdValue(formData?.shippingAddressId),
                billingAddress: normalizeText(formData?.billingAddressDisplay || formData?.billingAddress) || null,
                shippingAddress: normalizeText(formData?.shippingAddressDisplay || formData?.shippingAddress) || null,
                // legacy fields retained for backward compatibility
                billingId: toIdValue(formData?.billingContactId) || normalizeText(formData.billingName) || null,
                shippingId: toIdValue(formData?.shippingContactId) || normalizeText(formData.shippingName) || null,
                termsId: formData.terms,
                currency: formData.currency,
                defaultTax: formData.defaultTax,

            }

            payload.paymentNotes = normalizeText(formData.paymentNotes) || null;
            if (formData.finalizeManualPayment) {
                payload.finalizeManualPayment = true;
                payload.manualPaidOverride = true;
                payload.paymentReceivedAmount = resolveInvoiceTotalAmount(currentInvoice, formData) || null;
                payload.paymentReceivedDate = new Date().toISOString();
            } else {
                payload.finalizeManualPayment = false;
            }

            if (isManualMode) {
                payload.paymentMethod = 'others';
                payload.paymentType = normalizedPaymentType || null;
                payload.ChequeNumber = normalizedPaymentType === 'cheque' ? (normalizeText(formData.ChequeNumber) || null) : null;
                payload.accountHolderName = normalizedPaymentType === 'cheque' ? (normalizeText(formData.accountHolderName) || null) : null;
                payload.bankName = null;
                payload.bankAccountNumber = null;
                payload.routingNumber = null;
            }

            setLoading(true)
            const res = await updateInvoice(tabId, payload)
            toast.success(res?.message || 'Invoice updated successfully');

            await fetchInvoicesList(orderId)
            setLoading(false)
            handleClose()
        } catch (error) {
            setLoading(false)
            const serverErrors = error?.response?.data?.errors;
            if (serverErrors && typeof serverErrors === 'object') {
                setManualErrors((prev) => ({ ...prev, ...serverErrors }));
            }
            toast.error(error?.response?.data?.message || 'Failed to update invoice.');
        }
    }

    const fetchDetails = async () => {
        try {
            setLoading(true)
            let data = await getSingleinvoice(tabId);
            data = data.data
            if (data) {
                setInvoiceModeLabel(getInvoiceModeLabel(data));
                setStripeCheckoutLink(data?.checkoutLink || '');
                setCurrentInvoice(data);
                setFormData({
                    ...formData,
                    status: data.invoiceStatus || 'Open',
                    invoiceDate: dayjs(data?.invoiceDate) || currentDate,
                    introduction: data?.introduction || '',
                    billingAddress: typeof data?.billingAddress === 'string' ? data.billingAddress : (convertAddressToString(data?.billingAddress) || ''),
                    billingAddressId: data?.billingAddressId || '',
                    billingAddressDisplay: typeof data?.billingAddress === 'string' ? data.billingAddress : (convertAddressToString(data?.billingAddress) || ''),
                    billingName: data?.billingName || data?.billingId || '',
                    billingContactId: data?.billingContactId || data?.billingId || '',
                    billingId: data?.billingId || data?.billingContactId || '',
                    shippingAddress: typeof data?.shippingAddress === 'string' ? data.shippingAddress : (convertAddressToString(data?.shippingAddress) || ''),
                    shippingAddressId: data?.shippingAddressId || '',
                    shippingAddressDisplay: typeof data?.shippingAddress === 'string' ? data.shippingAddress : (convertAddressToString(data?.shippingAddress) || ''),
                    shippingName: data?.shippingName || data?.shippingId || '',
                    shippingContactId: data?.shippingContactId || data?.shippingId || '',
                    shippingId: data?.shippingId || data?.shippingContactId || '',
                    terms: data?.termsId ? parseInt(data.termsId) : null,
                    currency: data.currency || 'USD',
                    inHandsDate: dayjs(data?.inhandsDate) || currentDate,
                    defaultTax: data?.defaultTax || null,
                    invoiceView: data?.invoiceView || 'Detail',
                    paymentType: data?.paymentType || '',
                    ChequeNumber: data?.ChequeNumber || '',
                    accountHolderName: data?.accountHolderName || '',
                    bankName: data?.bankName || '',
                    bankAccountNumber: data?.bankAccountNumber || '',
                    routingNumber: data?.routingNumber || '',
                    paymentReceivedAmount: data?.paymentReceivedAmount || '',
                    paymentReceivedDate: data?.paymentReceivedDate || '',
                    paymentNotes: data?.paymentNotes || '',
                    finalizeManualPayment: false,
                });
            }
            setLoading(false)

        } catch (error) {
            console.error('Error fetching estimation details:', error);
            setLoading(false)
        }
    };
    const addressDropdownOptions = useMemo(() => {
        const byScope = addressScope === 'customer'
            ? allCustomerAddresses
            : addressScope === 'global'
                ? allGlobalAddresses
                : [...allCustomerAddresses, ...allGlobalAddresses];

        const merged = [];
        const seen = new Set();
        for (const address of byScope) {
            const displayKey = String(address?.display || convertAddressToString(address) || '').trim().toLowerCase();
            const idKey = String(address?.id ?? '').trim().toLowerCase();
            const key = idKey || displayKey;
            if (!key || seen.has(key)) continue;
            seen.add(key);
            merged.push({
                id: address.id,
                name: address.name || address.display || address.addressName || `${address.streetAddress || address.street || ''} - ${address.city || ''}`,
                label: address.label || address.addressName || address.name || '',
                addressName: address.addressName || address.address?.addressName || '',
                display: address.display || convertAddressToString(address),
                address: address.address || address,
                source: address.source || 'global',
            });
        }

        const q = String(addressQuery || '').trim().toLowerCase();
        if (!q) return merged;
        return merged.filter((address) =>
            String(address?.name || '').toLowerCase().includes(q) ||
            String(address?.display || '').toLowerCase().includes(q)
        );
    }, [allCustomerAddresses, allGlobalAddresses, addressScope, addressQuery]);
    useEffect(() => {
        setAddressOptions(addressDropdownOptions);
    }, [addressDropdownOptions]);

    useEffect(() => {
        const normalizedPropContacts = (clientContacts || []).map((contact) => ({
            ...contact,
            id: String(contact?.id ?? ''),
            name: contact?.name || contact?.email || 'Contact',
            email: contact?.email || '',
            type: 'client',
        }));

        const merged = [
            ...customerContactsOptions,
            ...normalizedPropContacts,
            ...supplierContactsOptions,
            ...thirdPartyContactsOptions,
        ];

        const seen = new Set();
        const deduped = merged.filter((contact) => {
            const idKey = String(contact?.id || '').trim().toLowerCase();
            const nameKey = String(contact?.name || '').trim().toLowerCase();
            const emailKey = String(contact?.email || '').trim().toLowerCase();
            const key = idKey || `${nameKey}|${emailKey}`;
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        setContactsOptions(deduped);
    }, [customerContactsOptions, supplierContactsOptions, thirdPartyContactsOptions, clientContacts]);

    const contactDropdownOptions = useMemo(() => {
        if (addressScope !== 'customer') return contactsOptions;
        if (customerContactsOptions?.length) return customerContactsOptions;
        // fallback: only client contacts when customer scope is active
        return (contactsOptions || []).filter((contact) => String(contact?.type || '').toLowerCase() === 'client');
    }, [addressScope, contactsOptions, customerContactsOptions]);

    useEffect(() => {
        if (!currentInvoice) return;
        if (!(contactsOptions?.length || addressDropdownOptions?.length)) return;

        setFormData((prev) => {
            const rawBillingContact = currentInvoice?.billingContactId ?? currentInvoice?.billingId ?? prev.billingContactId;
            const rawShippingContact = currentInvoice?.shippingContactId ?? currentInvoice?.shippingId ?? prev.shippingContactId;
            const rawBillingName = currentInvoice?.billingName ?? currentInvoice?.billingId ?? prev.billingName;
            const rawShippingName = currentInvoice?.shippingName ?? currentInvoice?.shippingId ?? prev.shippingName;
            const rawBillingAddress = currentInvoice?.billingAddress ?? prev.billingAddressDisplay ?? prev.billingAddress;
            const rawShippingAddress = currentInvoice?.shippingAddress ?? prev.shippingAddressDisplay ?? prev.shippingAddress;
            const rawBillingAddressId = currentInvoice?.billingAddressId ?? prev.billingAddressId;
            const rawShippingAddressId = currentInvoice?.shippingAddressId ?? prev.shippingAddressId;

            const nextBillingContactId = findContactIdByText(rawBillingContact) || String(prev.billingContactId || '');
            const nextShippingContactId = findContactIdByText(rawShippingContact) || String(prev.shippingContactId || '');
            const nextBillingAddressId = resolveAddressId(rawBillingAddressId, rawBillingAddress, addressDropdownOptions) || String(prev.billingAddressId || '');
            const nextShippingAddressId = resolveAddressId(rawShippingAddressId, rawShippingAddress, addressDropdownOptions) || String(prev.shippingAddressId || '');

            const billingContactOption = (contactsOptions || []).find((option) => String(option?.id) === String(nextBillingContactId));
            const shippingContactOption = (contactsOptions || []).find((option) => String(option?.id) === String(nextShippingContactId));
            const nextBillingName = String(rawBillingName || billingContactOption?.name || prev.billingName || '');
            const nextShippingName = String(rawShippingName || shippingContactOption?.name || prev.shippingName || '');
            const nextBillingDisplay = typeof rawBillingAddress === 'string'
                ? rawBillingAddress
                : (addressDropdownOptions.find((opt) => String(opt.id) === String(nextBillingAddressId))?.display || prev.billingAddressDisplay || '');
            const nextShippingDisplay = typeof rawShippingAddress === 'string'
                ? rawShippingAddress
                : (addressDropdownOptions.find((opt) => String(opt.id) === String(nextShippingAddressId))?.display || prev.shippingAddressDisplay || '');

            if (
                String(prev.billingContactId || '') === nextBillingContactId &&
                String(prev.shippingContactId || '') === nextShippingContactId &&
                String(prev.billingAddressId || '') === nextBillingAddressId &&
                String(prev.shippingAddressId || '') === nextShippingAddressId &&
                String(prev.billingName || '') === String(nextBillingName || '') &&
                String(prev.shippingName || '') === String(nextShippingName || '') &&
                String(prev.billingAddressDisplay || '') === String(nextBillingDisplay || '') &&
                String(prev.shippingAddressDisplay || '') === String(nextShippingDisplay || '')
            ) {
                return prev;
            }

            return {
                ...prev,
                billingContactId: nextBillingContactId,
                shippingContactId: nextShippingContactId,
                billingId: nextBillingContactId || prev.billingId,
                shippingId: nextShippingContactId || prev.shippingId,
                billingName: nextBillingName,
                shippingName: nextShippingName,
                billingAddressId: nextBillingAddressId,
                shippingAddressId: nextShippingAddressId,
                billingAddress: nextBillingDisplay,
                shippingAddress: nextShippingDisplay,
                billingAddressDisplay: nextBillingDisplay,
                shippingAddressDisplay: nextShippingDisplay,
            };
        });
    }, [currentInvoice, contactsOptions, addressDropdownOptions]);

    const getAddressPreview = (selectedAddressId, fallbackDisplay = '') => {
        if (!selectedAddressId && !fallbackDisplay) return '';
        const matched = addressOptions.find((opt) => String(opt.id) === String(selectedAddressId));
        if (matched) return String(matched.display || matched.name || fallbackDisplay || '');
        return String(fallbackDisplay || selectedAddressId);
    };

    useEffect(() => {
        if (!showInvoiceCustomization || customizationOptionsLoaded) return;
        let active = true;
        setCustomizationOptionsLoading(true);
        Promise.all([
            fetchTermsAndTaxes(),
            order ? fetchCustomerDetails() : Promise.resolve(),
        ]).finally(() => {
            if (!active) return;
            setCustomizationOptionsLoaded(true);
            setCustomizationOptionsLoading(false);
        });
        return () => {
            active = false;
        };
    }, [showInvoiceCustomization, customizationOptionsLoaded, order])
    useEffect(() => {
        if (tabId && tabId !== 'new') {
            fetchDetails()
        };
    }, [tabId]);
    useEffect(() => {
        setActiveEditTab('details');
        setShowInvoiceCustomization(false);
        setCustomizationOptionsLoaded(false);
    }, [tabId]);
    useEffect(() => {
        if (!orderId || !instanceUniqueId || !currentInvoice?.id || activeEditTab !== 'email-history') return undefined;
        let active = true;
        setInvoiceEmailHistory({ events: [], loading: true, error: '' });
        fetchInvoiceEmailHistoryByOrder(orderId, { instanceUniqueId })
            .then((result) => {
                if (!active) return;
                const events = Array.isArray(result?.events) ? result.events : [];
                setInvoiceEmailHistory({
                    events: events.filter((event) => String(event.invoiceId) === String(currentInvoice.id)),
                    loading: false,
                    error: '',
                });
            })
            .catch((error) => {
                if (!active) return;
                setInvoiceEmailHistory({
                    events: [],
                    loading: false,
                    error: error?.response?.data?.message || 'Could not load invoice email history.',
                });
            });
        return () => { active = false; };
    }, [orderId, instanceUniqueId, currentInvoice?.id, activeEditTab, invoiceEmailHistoryRefresh]);

    const invoiceTotal = resolveInvoiceTotalAmount(currentInvoice, formData);
    const invoiceCurrency = currentInvoice?.currency || formData.currency || 'CAD';
    const invoiceContext = useMemo(() => {
        if (!currentInvoice) return null;

        const parseObject = (value) => {
            if (!value) return {};
            if (typeof value === 'object') return value;
            try { return JSON.parse(value) || {}; } catch (_) { return {}; }
        };

        const relationships = parseObject(currentInvoice.invoiceRelationships);
        const summary = currentInvoice.paymentSummary || {};
        const accountingRef = parseObject(currentInvoice.accountingRef);
        const history = accountingRef?.thirdParty?.invoiceHistory || {};
        const gross = Number(
            summary.grossInvoiceTotal
            || relationships.orderTotal
            || history.orderTotal
            || (Number(history.orderTotalCents) > 0 ? Number(history.orderTotalCents) / 100 : 0)
            || 0
        );
        const priorDeposit = Number(
            summary.priorDepositPaid
            || relationships.priorDepositPaid
            || history.priorDepositPaid
            || (Number(history.priorDepositPaidCents) > 0 ? Number(history.priorDepositPaidCents) / 100 : 0)
            || 0
        );
        const role = String(
            relationships.role
            || history?.balanceClassification?.role
            || ''
        ).trim().toLowerCase();

        let label = 'Invoice';
        if (role.includes('deposit')) label = 'Deposit invoice';
        else if (role === 'balance' || priorDeposit > 0) label = 'Balance invoice';
        else if (gross > 0 && Number(invoiceTotal) < gross) label = 'Follow-up invoice';
        else if (gross > 0 && Math.abs(Number(invoiceTotal) - gross) < 0.01) label = 'Full invoice';

        const percentage = gross > 0
            ? Math.min(100, Math.max(0, (Number(invoiceTotal || 0) / gross) * 100))
            : null;

        return {
            label,
            gross: gross > 0 ? gross : null,
            percentage,
            priorDeposit: priorDeposit > 0 ? priorDeposit : null,
        };
    }, [currentInvoice, invoiceTotal]);

    return (
        <>
            {loading ? (
                <LoadingComponent />
            ) : (
                <Box>
                    <Tabs
                        value={activeEditTab}
                        onChange={(_event, value) => setActiveEditTab(value)}
                        aria-label="Invoice edit tabs"
                        sx={{
                            mb: 2,
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                            '& .MuiTab-root': { textTransform: 'none', fontWeight: 700 },
                        }}
                    >
                        <Tab value="details" label="Invoice Details" />
                        <Tab value="cart" label="Line Items" disabled={!invoicingCartKey} />
                        <Tab value="email-history" label="Email History" />
                    </Tabs>

                    {activeEditTab === 'cart' ? (
                        <InvoiceCartTab
                            orderId={orderId}
                            order={order}
                            instanceUniqueId={instanceUniqueId}
                            invoicingCartKey={invoicingCartKey}
                            activeInvoicingCartSummary={activeInvoicingCartSummary}
                            currency={invoiceCurrency}
                            invoice={currentInvoice}
                            onCartSaved={fetchInvoicesList}
                        />
                    ) : activeEditTab === 'email-history' ? (
                        <SalesOrderInvoiceEmailHistory
                            events={invoiceEmailHistory.events}
                            loading={invoiceEmailHistory.loading}
                            error={invoiceEmailHistory.error}
                            showWhenEmpty
                            defaultExpanded
                            onRefresh={() => setInvoiceEmailHistoryRefresh((value) => value + 1)}
                        />
                    ) : (
                <form>
                    {/* Active invoicing-cart diagnostics intentionally hidden from the Invoice Details UI. */}

                    <Box sx={{ width: '100%', maxWidth: 'none', px: 0 }}>
                        <Box
                            sx={{
                                mb: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                                gap: 2,
                                flexWrap: 'wrap',
                            }}
                        >
                            <Box>
                                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
                                    Invoice Total
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 0.25 }}>
                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                        {formatInvoiceTotal(invoiceTotal, invoiceCurrency)}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                                        {String(invoiceCurrency).toUpperCase()}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 700 }}>
                                    {invoiceContext?.label || 'Invoice'}
                                </Typography>
                                {invoiceContext?.gross ? (
                                    <Typography variant="caption" color="text.secondary">
                                        {formatInvoiceTotal(invoiceTotal, invoiceCurrency)} of {formatInvoiceTotal(invoiceContext.gross, invoiceCurrency)}
                                        {invoiceContext.percentage != null ? ` · ${invoiceContext.percentage.toFixed(0)}%` : ''}
                                        {invoiceContext.priorDeposit ? ` · Deposit already paid ${formatInvoiceTotal(invoiceContext.priorDeposit, invoiceCurrency)}` : ''}
                                    </Typography>
                                ) : null}
                            </Box>
                        </Box>

                        <Box className="field">
                            <CustomTextField
                                label="Additional Notes"
                                value={formData.paymentNotes}
                                name="paymentNotes"
                                placeholder="Add any payment notes, confirmation details, or internal context here."
                                handleChange={handleInputChange}
                                error={!!manualErrors.paymentNotes}
                                helperText={manualErrors.paymentNotes}
                            />
                        </Box>

                        <Box sx={{ mt: 1 }}>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={!!formData.finalizeManualPayment}
                                        onChange={(e) => handleInputChange(e, 'finalizeManualPayment')}
                                        disabled={isAlreadyPaidStripeInvoice}
                                    />
                                )}
                                label="Mark this invoice as paid now"
                            />
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', ml: 4 }}>
                                {isAlreadyPaidStripeInvoice
                                    ? 'This invoice is already paid through Stripe.'
                                    : `This will mark the full invoice amount (${formatInvoiceTotal(invoiceTotal, invoiceCurrency)}) as paid.`}
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                            <Tooltip title="Customize invoice display">
                                <Button
                                    variant="text"
                                    size="small"
                                    startIcon={<PaletteOutlinedIcon />}
                                    onClick={() => setShowInvoiceCustomization((visible) => !visible)}
                                    aria-expanded={showInvoiceCustomization}
                                    aria-controls="invoice-display-customization"
                                    sx={{ textTransform: 'none', fontWeight: 600 }}
                                >
                                    {showInvoiceCustomization ? 'Hide Invoice Display Options' : 'Customize Invoice Display'}
                                </Button>
                            </Tooltip>
                        </Box>

                        <Collapse in={showInvoiceCustomization} timeout="auto" unmountOnExit>
                            <Box id="invoice-display-customization" sx={{ mt: 1.5 }}>
                                <Divider sx={{ mb: 2.5 }} />
                                {customizationOptionsLoading && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                        <CircularProgress size={18} />
                                        <Typography variant="body2" color="text.secondary">
                                            Loading invoice display options…
                                        </Typography>
                                    </Box>
                                )}

                                <Grid container spacing={2} alignItems="flex-start">
                                    <Grid item xs={12} sm={6} md={4}>
                                        <Box className="field">
                                            <CustomDropdown label="Status" isRequired={true} name="status" handleSelect={handleSelect} selectedValue={formData.status} options={statusOptions} />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Box className="field">
                                            <CustomTextField
                                                label="Invoice Date"
                                                name="invoiceDateDisplay"
                                                value={formData.invoiceDate?.isValid?.() ? formData.invoiceDate.format('MM/DD/YYYY') : ''}
                                                disabled={true}
                                                handleChange={() => {}}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Box>
                                            <CurrencyDropdown name="currency" isRequired={true} handleSelect={handleSelect} selectedValue={formData.currency} options={currencyOptions} disabled={isGeneratedInvoice} />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Box className="field">
                                            <CustomDropdown isRequired={true} label="Default Tax" name="defaultTax" handleSelect={handleSelect} selectedValue={formData.defaultTax} options={taxOptions} disabled={isGeneratedInvoice} />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <Box className="field">
                                            <CustomDropdown label="Terms" isRequired={true} name="terms" handleSelect={handleSelect} selectedValue={formData.terms} options={termsOptions} disabled={isGeneratedInvoice} />
                                        </Box>
                                    </Grid>

                                    {String(invoiceModeLabel).toLowerCase() === 'stripe' && stripeCheckoutLink ? (
                                        <Grid item xs={12}>
                                            <Typography variant="body2">
                                                Stripe link: <a href={stripeCheckoutLink} target="_blank" rel="noopener noreferrer">Open checkout</a>
                                            </Typography>
                                        </Grid>
                                    ) : null}

                                    <Grid item xs={12}>
                                        <Box className="address-main-container">
                                            <Box className="search-address-filter-bar" sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1, px: 0.25, flexWrap: 'wrap' }}>
                                                <Tooltip title="Customer addresses">
                                                    <IconButton size="small" onClick={() => setAddressScope('customer')} color={addressScope === 'customer' ? 'primary' : 'default'}>
                                                        <PeopleAltOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Global addresses">
                                                    <IconButton size="small" onClick={() => setAddressScope('global')} color={addressScope === 'global' ? 'primary' : 'default'}>
                                                        <PublicOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Show all">
                                                    <IconButton size="small" onClick={() => setAddressScope('all')} color={addressScope === 'all' ? 'primary' : 'default'}>
                                                        <AllInboxOutlinedIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                                <TextField
                                                    size="small"
                                                    placeholder="Search addresses"
                                                    value={addressQuery}
                                                    onChange={(e) => setAddressQuery(e.target.value)}
                                                    sx={{ ml: { xs: 0, sm: 0.5 }, minWidth: 220, flex: 1 }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Box>

                                            <Grid container spacing={1.5}>
                                                <Grid item xs={12} md={6}>
                                                    <Box className="field client-address-container">
                                                        <CustomDropdown isRequired={true} label="Billing Address" name="billingAddressId" handleSelect={handleSelect} selectedValue={formData.billingAddressId} options={addressDropdownOptions} addPlusIcon={true} />
                                                        <CustomDropdown isRequired={true} placeholder="Billing Contact" name="billingContactId" handleSelect={handleSelect} selectedValue={formData.billingContactId} options={contactDropdownOptions} addPlusIcon={true} />
                                                        {formData.billingName && <Typography className="addressDetails">{formData.billingName}</Typography>}
                                                        {(formData.billingAddressId || formData.billingAddressDisplay) && (
                                                            <Typography className="addressDetails">
                                                                {getAddressPreview(formData.billingAddressId, formData.billingAddressDisplay || formData.billingAddress)}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <Box className="field client-address-container">
                                                        <CustomDropdown isRequired={true} label="Shipping Address" name="shippingAddressId" handleSelect={handleSelect} selectedValue={formData.shippingAddressId} options={addressDropdownOptions} addPlusIcon={true} />
                                                        <CustomDropdown isRequired={true} placeholder="Shipping Contact" name="shippingContactId" handleSelect={handleSelect} selectedValue={formData.shippingContactId} options={contactDropdownOptions} addPlusIcon={true} />
                                                        {formData.shippingName && <Typography className="addressDetails">{formData.shippingName}</Typography>}
                                                        {(formData.shippingAddressId || formData.shippingAddressDisplay) && (
                                                            <Typography className="addressDetails">
                                                                {getAddressPreview(formData.shippingAddressId, formData.shippingAddressDisplay || formData.shippingAddress)}
                                                            </Typography>
                                                        )}
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Grid>

                                    {isManualMode && (
                                        <Grid item xs={12}>
                                            <Box className="field">
                                                <CustomDropdown
                                                    label="Manual Payment Type"
                                                    isRequired={true}
                                                    name="paymentType"
                                                    handleSelect={handleSelect}
                                                    selectedValue={formData.paymentType}
                                                    options={paymentTypeOptions}
                                                />
                                                {manualErrors.paymentType && <Typography color="error" variant="caption">{manualErrors.paymentType}</Typography>}
                                                {formData.paymentType === 'cheque' && (
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} md={6}>
                                                            <CustomTextField
                                                                label="Cheque Number"
                                                                value={formData.ChequeNumber}
                                                                name="ChequeNumber"
                                                                placeholder="Enter cheque number"
                                                                handleChange={handleInputChange}
                                                                error={!!manualErrors.ChequeNumber}
                                                                helperText={manualErrors.ChequeNumber}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} md={6}>
                                                            <CustomTextField
                                                                label="Account Holder Name"
                                                                value={formData.accountHolderName}
                                                                name="accountHolderName"
                                                                placeholder="Enter account holder"
                                                                handleChange={handleInputChange}
                                                                error={!!manualErrors.accountHolderName}
                                                                helperText={manualErrors.accountHolderName}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                {formData.paymentType === 'etf' && (
                                                    <Typography variant="caption" color="text.secondary">
                                                        EFT details are captured as a high-level note only (no account/routing fields stored).
                                                    </Typography>
                                                )}
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                            </Box>
                        </Collapse>

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, mt: 3, flexWrap: 'wrap' }}>
                            <Button
                                variant="contained"
                                onClick={updateEstimationDetails}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px !important',
                                    color: 'white',
                                    backgroundColor: '#c3171d',
                                    '&:hover': {
                                        backgroundColor: 'white',
                                        color: '#c3171d',
                                        border: '1px solid #c3171d',
                                    },
                                    width: 200,
                                    fontWeight: 600,
                                }}
                            >
                                {loading ? <ButtonLoader /> : 'Save'}
                            </Button>
                            {tabId && tabId !== 'new' ? (
                                <Button variant="outlined" onClick={handleOpenSendEmail} sx={{ textTransform: 'none', width: 200, fontWeight: 600 }}>
                                    Send Email
                                </Button>
                            ) : null}
                        </Box>
                    </Box>
                </form>
                    )}
                </Box>
            )}
        </>
    );

}

export default InvoiceEdit
